import { IOrderBillClaim } from './orderBillClaim.model.interface';

export class OrderBillClaim implements IOrderBillClaim {
  readonly idNumber: string;

  constructor(data: IOrderBillClaim) {
    this.idNumber = data.idNumber;
  }
}
